import React from "react";
import styled from "styled-components";
// Components
import BlogBox from "../Elements/BlogBox";
import FullButton from "../Buttons/FullButton";
import TestimonialSlider from "../Elements/TestimonialSlider";

export default function Blog() {
  return (
    <Wrapper id="insights">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">LegalTech insights</h1>
            <p className="font13">
              To strengthen credibility and search visibility, Click Law hosts a LegalTech Insights Hub.
              <br />
              This positions Click Law not only as a product, but as a thought leader in LegalTech across Southern Africa.
            </p>
          </HeaderInfo>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="The future of AI in legal practice"
                text="How artificial intelligence is reshaping legal research, drafting, and practice management—and what it means for your firm."
                tag="Insight"
                author="Click Law"
                action={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="Digital transformation in African law firms"
                text="Why law firms across the continent are adopting integrated platforms and intelligent tools to stay competitive and compliant."
                tag="Insight"
                author="Click Law"
                action={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="Cybersecurity for legal professionals"
                text="Confidentiality and data protection are non-negotiable. Best practices for securing client information and legal workflows."
                tag="Insight"
                author="Click Law"
                action={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
              />
            </div>
          </div>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="Technology adoption in African legal systems"
                text="How jurisdiction-aware technology and local compliance requirements are driving the next wave of legal practice tools."
                tag="Insight"
                author="Click Law"
                action={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="LegalTech across Southern Africa"
                text="Thought leadership and practical guidance for firms ready to modernise their practice with secure, intelligent infrastructure."
                tag="Insight"
                author="Click Law"
                action={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="Preparing your firm for the future"
                text="The future of the legal profession will belong to firms that are organised, intelligent, and technologically empowered."
                tag="Insight"
                author="Click Law"
                action={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
              />
            </div>
          </div>
          <div className="row flexCenter">
            <div style={{ margin: "50px 0", width: "220px" }}>
              <FullButton title="Demo" action={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })} />
            </div>
          </div>
        </div>
      </div>
      <div className="lightBg" style={{padding: '50px 0'}}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">What they say</h1>
            <p className="font13">
              Click Law is the digital backbone of modern legal practice. Hear from firms that have made the transition to intelligent, secure infrastructure.
            </p>
          </HeaderInfo>
          <TestimonialSlider />
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding-top: 20px;
`;
const HeaderInfo = styled.div`
  margin-bottom: 30px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;